import { useState } from 'react';
import useGetCompanyCultureReviewQuery from '~hooks/query/company/useCompanyCultureReview';
import { useRouterQuery } from '~hooks/useRouterQuery';

import ModalCultureReview from '../ModalCultureReview';
import BarChart from './BarChart';
import ButtonMore from '../ButtonMore';
import * as S from './style';

interface Props {
  isSummary?: boolean;
}

function ChartContents({ isSummary }: Props) {
  const companyHash = useRouterQuery('companyId');
  const { data } = useGetCompanyCultureReviewQuery(companyHash);
  const cultureList = isSummary ? data?.cultureList.slice(0, 4) : data?.cultureList;

  return (
    <S.ChartSectionWrapper>
      {cultureList?.map((item, index) => (
        <S.ChartContent key={index}>
          <S.ChartTitle typography='midium150_B3'>{item.content}</S.ChartTitle>
          <BarChart chartData={item.chartData} />
          <S.Legend>
            <span>{item.chartData.leftData.legend}</span>
            <span>{item.chartData.rightData.legend}</span>
          </S.Legend>
        </S.ChartContent>
      ))}
    </S.ChartSectionWrapper>
  );
}

export default ChartContents;
